import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { HelpFabComponent } from './help-fab/help-fab.component';

@NgModule({
  declarations: [HelpFabComponent],
  imports: [CommonModule, MatIconModule, MatTooltipModule],
  exports: [HelpFabComponent],
})
export class HelpModule {}
